import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, input, output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { buttonColor } from '@mwe/models';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-button',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslatePipe],
})
export class ButtonComponent {
  buttonId = input<string>();
  labelKey = input<string>();
  buttonType = input<HTMLButtonElement['type']>('button');
  disabled = input<boolean>(false);
  showSpinner = input<boolean>(false);
  emitEventWithRoute = input<boolean>(false);
  clicked = output<MouseEvent>();
  hasFullWidth = input<boolean>(false);
  route = input<string>();
  url = input<string>();
  color = input<buttonColor>('dark-blue');
  category = input<'primary' | 'secondary' | 'tertiary'>('primary');
  showHoverEffect = input<boolean>(false);
  hasBlueBackground = input<boolean>(false);
  size = input<'lg' | 'md' | 'sm' | 'xs'>('lg');
  title = input<string>();
  prependIconClass = input<string>();
  appendIconClass = input<string>();
  isIconBtn = input<boolean>(false);
  ariaExpanded = input<true | false | null>(null);
  ariaDescription = input<string>();

  @ViewChild('btnElement') buttonElement: ElementRef<HTMLElement>;

  btnCssClasses = computed<string[]>(() => {
    const btnTypeCss = `btn-${this.category()}--${this.color()}`;
    const hoverClass = this.showHoverEffect() && this.category() === 'primary' ? 'hover-effect' : '';
    const classes = ['btn', btnTypeCss, hoverClass];
    if (this.hasFullWidth()) {
      classes.push('w-100');
    }

    if (this.isIconBtn()) {
      classes.push('btn-icon');
    }

    if (this.hasBlueBackground()) {
      classes.push('btn-focus-white');
    }

    if (this.size() && this.size() !== 'lg') {
      classes.push(`btn-${this.size()}`);
    }

    return classes;
  });
  waveCssClass = computed(() => (this.color() !== 'orange' ? `wave--${this.color()}` : ''));

  private router = inject(Router);

  onClick($event: MouseEvent): void {
    // $event.stopPropagation();
    if (this.disabled()) {
      $event.preventDefault();
      return;
    }

    if (this.route()) {
      this.router.navigateByUrl(this.route());

      if (this.emitEventWithRoute()) {
        this.clicked.emit($event);
      }
      return;
    }

    if (this.url()) {
      window.open(this.url(), '_blank');
      return;
    }

    this.clicked.emit($event);
  }
}
